import get from 'lodash.get';
import React from 'react';
import { useTheme } from 'styled-components/macro';
import {
  IArticlesData,
  IJournalsCategoriesItem,
  IJournalsData,
  INewsData,
  IRootState,
} from 'constants/types';
import { useSelector } from 'react-redux';
import { States } from 'constants/states';
import Loader from 'components/Loader/Loader';
import Breakpoints from 'themes/constants/breakpoints';
import { ITheme } from 'themes/constants/themes';
import { ButtonThemeType } from 'components/Button/Button';
import RoutePath from 'routes/constants/routes';
import { useHistory } from 'react-router-dom';
import { ReactComponent as ArrowIcon } from 'media/icons/arrow-circle-right.svg';
import map from 'lodash.map';
import { getImageCategoriesById } from 'utils/get';
import JournalsSliderMain from 'components/Jouranls/slider/main/JournalsSliderMain';
import queryString from 'query-string';
import { ArticlesType } from 'components/Articles/card/ArticlesCard';
import ArticlesSliderMain from 'components/Articles/slider/main/ArticlesSliderMain';
import { useMediaQuery } from 'react-responsive';
import placeholder from 'media/images/placeholder.jpg';
import { JournalsCardType } from 'components/Jouranls/card/JournalsCard';
import useTranslate from 'hooks/useTranslate';
import SectionsContent from 'components/Sections/content/SectionsContent';
import NewsSliderMain from 'components/News/slider/main/NewsSliderMain';
import { BooksType } from 'components/Books/card/BooksCardTypes';
import BooksSliderMain from 'components/Books/slider/main/BooksSliderMain';
import BooksCardBig from 'components/Books/cardBig/BooksCardBig';
import { BooksCardBigThemeType } from 'components/Books/cardBig/BooksCardBigTypes';
import BannersSliderMain from 'components/Banners/slider/BannersSliderMain';
import TitleMain from 'components/TitleMain/TitleMain';
import {
  Articles,
  BooksSelectedInner,
  Button,
  ButtonInner,
  Content,
  HeadArticles,
  HomeTabs,
  ThematicCard,
  ThematicCardImg,
  ThematicCards,
  Title,
  TitleLinkArrow,
} from './HomeViewStyles';

export enum TabArticles {
  POPULAR = 'popular',
  NEW = 'new',
}

const HomeView = () => {
  const theme: ITheme = useTheme();

  const [getText] = useTranslate();

  const history = useHistory();
  const search = history.location.search || '';
  const queries = queryString.parse(search);
  const tabArticlesQuery = queries?.tabArticles as TabArticles || TabArticles.POPULAR;
  const tabBooksQuery = queries?.tabBooks as BooksType || BooksType.EBOOK;

  const bannersState = useSelector((state: IRootState) => get(state, [States.BANNERS]));
  const bannersLoading = get(bannersState, ['loading']);
  const bannersData = get(bannersState, ['data'], []);

  const booksPopularState = useSelector((state: IRootState) => get(state, [States.BOOKS_POPULAR]));
  const booksPopularLoading = get(booksPopularState, ['loading']);
  const booksPopularData = get(booksPopularState, ['data'], []);

  const booksNewState = useSelector((state: IRootState) => get(state, [States.BOOKS_NEW]));
  const booksNewLoading = get(booksNewState, ['loading']);
  const booksNewData = get(booksNewState, ['data'], []);

  const booksParentsState = useSelector((state: IRootState) => get(state, [States.BOOKS_PARENTS]));
  const booksParentsLoading = get(booksParentsState, ['loading']);
  const booksParentsData = get(booksParentsState, ['data'], []);

  const booksRecommendState = useSelector((state: IRootState) => get(state, [States.BOOKS_RECOMMENDED]));
  const booksRecommendLoading = get(booksRecommendState, ['loading']);
  const booksRecommendData = get(booksRecommendState, ['data'], []);

  const journalsCategoriesState = useSelector((state: IRootState) => get(state, [States.JOURNALS_CATEGORIES]));
  const journalsCategoriesLoading = get(journalsCategoriesState, ['loading']);
  const journalsCategoriesData = get(journalsCategoriesState, ['data'], []);

  const journalsNewState = useSelector((state: IRootState) => get(state, [States.JOURNALS_NEW]));
  const journalsNewLoading = get(journalsNewState, ['loading']);
  const journalsNewData: IJournalsData = get(journalsNewState, ['data'], []);

  const journalsRecommendedState = useSelector((state: IRootState) => get(state, [States.JOURNALS_RECOMMENDED]));
  const journalsRecommendedLoading = get(journalsRecommendedState, ['loading']);
  const journalsRecommendedData: IJournalsData = get(journalsRecommendedState, ['data'], []);

  const journalsFreeState = useSelector((state: IRootState) => get(state, [States.JOURNALS_FREE]));
  const journalsFreeLoading = get(journalsFreeState, ['loading']);
  const journalsFreeData: IJournalsData = get(journalsFreeState, ['data'], []);

  const articlesTopState = useSelector((state: IRootState) => get(state, [States.ARTICLES_TOP]));
  const articlesTopLoading = get(articlesTopState, ['loading']);
  const articlesTopData: IArticlesData = get(articlesTopState, ['data'], []);

  const articlesNewState = useSelector((state: IRootState) => get(state, [States.ARTICLES_NEW]));
  const articlesNewLoading = get(articlesNewState, ['loading']);
  const articlesNewData: IArticlesData = get(articlesNewState, ['data'], []);

  const newsNewState = useSelector((state: IRootState) => get(state, [States.NEWS_NEW]));
  const newsNewLoading = get(newsNewState, ['loading']);
  const newsNewData: INewsData = get(newsNewState, ['data'], []);

  const isTabletES = useMediaQuery({ query: `(${Breakpoints.TABLET_ES})` });
  const isTablet = useMediaQuery({ query: `(${Breakpoints.TABLET})` });
  const isLaptop = useMediaQuery({ query: `(${Breakpoints.LAPTOP})` });

  const handleSetBooksType = (type: BooksType) => history.replace({ search: queryString.stringify({ ...queries, tabBooks: type }) });

  const booksTitle = (
    <SectionsContent withPaddings={false}>
      <TitleMain withMargin={false}>
        {getText(['pages', 'books'])}
      </TitleMain>
    </SectionsContent>
  );

  const bannersSelection = (
    <SectionsContent withShadows={false}>
      <BannersSliderMain
        data={bannersData}
        loading={bannersLoading}
      />
    </SectionsContent>
  );

  const booksTypesSelection = (
    <SectionsContent withPaddings={false} withInner={false}>
      <ButtonInner>
        <Button
          onClick={() => handleSetBooksType(BooksType.EBOOK)}
          themeType={tabBooksQuery === BooksType.EBOOK ? ButtonThemeType.PRIMARY : ButtonThemeType.MINOR}
        >
          {getText(['words', 'read'])}
        </Button>
        <Button
          onClick={() => handleSetBooksType(BooksType.ABOOK)}
          themeType={tabBooksQuery === BooksType.ABOOK ? ButtonThemeType.PRIMARY : ButtonThemeType.MINOR}
        >
          {getText(['words', 'listen'])}
        </Button>
      </ButtonInner>
    </SectionsContent>
  );

  const booksPopularSelection = (
    <SectionsContent>
      <Title>{getText(['words', 'worldPopular'])}</Title>
      <BooksSliderMain
        data={booksPopularData}
        loading={booksPopularLoading}
      />
    </SectionsContent>
  );

  const booksNewSelection = (
    <SectionsContent>
      <Title>{getText(['words', 'new'])}</Title>
      <BooksSliderMain
        data={booksNewData?.slice(isTablet ? 2 : 1)}
        loading={booksNewLoading}
      />
    </SectionsContent>
  );

  const booksSelectedSelection = booksNewLoading ? null : (
    <SectionsContent withPaddings={false} withShadows={false}>
      <BooksSelectedInner>
        {booksNewData
          ?.slice(0, isTablet ? 2 : 1)
          ?.map((item, index) => (
            <BooksCardBig
              item={item}
              themeType={index === 0 ? BooksCardBigThemeType.PRIMARY : BooksCardBigThemeType.SECONDARY}
              key={item.bookId}
            />
          ))}
      </BooksSelectedInner>
    </SectionsContent>
  );

  const booksParentsSelection = (
    <SectionsContent>
      <Title>{getText(['words', 'forParents'])}</Title>
      <BooksSliderMain
        data={booksParentsData}
        loading={booksParentsLoading}
      />
    </SectionsContent>
  );

  const booksRecommendSelection = (
    <SectionsContent>
      <Title>{getText(['words', 'weRecommend'])}</Title>
      <BooksSliderMain
        data={booksRecommendData}
        loading={booksRecommendLoading}
      />
    </SectionsContent>
  );

  const allBooksSelection = (
    <SectionsContent withInner={false}>
      <ButtonInner>
        <Button onClick={() => history.push(RoutePath.BOOKS_CATEGORIES_PATH)} themeType={ButtonThemeType.PRIMARY}>
          {getText(['words', 'allBooks'])}
        </Button>
      </ButtonInner>
    </SectionsContent>
  );

  const selectEditorSelection = (
    <SectionsContent>
      <Title>{getText(['words', 'selectEditor'])}</Title>
      <JournalsSliderMain
        data={journalsRecommendedData}
        loading={journalsRecommendedLoading}
      />
    </SectionsContent>
  );

  const freeSelection = (
    <SectionsContent background={theme.palette.green}>
      <Title color={theme.palette.white}>{getText(['words', 'free'])}</Title>
      <JournalsSliderMain
        data={journalsFreeData}
        loading={journalsFreeLoading}
        type={JournalsCardType.ISSUE}
      />
    </SectionsContent>
  );

  const thematicSelection = (
    <SectionsContent>
      <Title>{getText(['words', 'thematicSelections'])}</Title>
      {
        journalsCategoriesLoading
          ? <Loader />
          : (
            <ThematicCards>
              {map(journalsCategoriesData, ((item: IJournalsCategoriesItem) => {
                const { name = '', id } = item;
                const imgSrc = getImageCategoriesById(id);
                if (imgSrc) {
                  return (
                    <ThematicCard
                      onClick={() => {
                        history.push(`${RoutePath.JOURNALS_PATH}/${id}`);
                      }}
                      key={id}
                    >
                      <ThematicCardImg>
                        <img
                          onError={(e: any) => {
                            e.target.onerror = null;
                            e.target.src = placeholder;
                          }}
                          decoding="async"
                          src={imgSrc}
                          alt={`${name}`}
                        />
                      </ThematicCardImg>
                      <span>{name}</span>
                    </ThematicCard>
                  );
                }
                return null;
              }))}
            </ThematicCards>
          )
      }
    </SectionsContent>
  );

  const journalsTitle = (
    <SectionsContent withPaddings={false}>
      <TitleMain withoutMargin>
        {getText(['pages', 'journals'])}
      </TitleMain>
    </SectionsContent>
  );

  const newJournalsSelection = (
    <SectionsContent background={theme.palette.redGradient}>
      <Title color={theme.palette.white}>
        {getText(['words', 'newJournals'])}
      </Title>
      <JournalsSliderMain
        data={journalsNewData}
        loading={journalsNewLoading}
        isDark
      />
    </SectionsContent>
  );

  const allJournalsSelection = (
    <SectionsContent withInner={false}>
      <ButtonInner>
        <Button onClick={() => history.push(RoutePath.JOURNALS_CATEGORIES_PATH)} themeType={ButtonThemeType.SECONDARY}>
          {getText(['words', 'allJournals'])}
        </Button>
      </ButtonInner>
    </SectionsContent>
  );

  const isArticlesNew = tabArticlesQuery === TabArticles.NEW;

  const renderArticlesList = (arr: IArticlesData) => {
    if (Array.isArray(arr) && JSON.stringify(arr) !== '[]') {
      const restArticlesArr = arr.slice(isTablet ? 3 : isTabletES ? 2 : 1);

      return (
        <Articles>
          {!isLaptop && (
            <HeadArticles>
              <ArticlesSliderMain
                data={arr}
                type={ArticlesType.CARD_MAIN}
              />

            </HeadArticles>
          )}
          {isLaptop ? (
            <ArticlesSliderMain
              data={isLaptop ? arr : restArticlesArr}
              type={ArticlesType.CARD_MAIN}
            />
          ) : null}
        </Articles>
      );
    }
    return null;
  };

  const articlesPopular = articlesTopLoading ? <Loader /> : (renderArticlesList(articlesTopData));
  const articlesNew = articlesNewLoading ? <Loader /> : (renderArticlesList(articlesNewData));

  const articlesTabs = [
    { name: getText(['words', 'popularItems']), value: TabArticles.POPULAR },
    { name: getText(['words', 'newItems']), value: TabArticles.NEW },
  ];

  const articlesSelection = (
    <SectionsContent>
      <TitleLinkArrow onClick={() => history.push(RoutePath.ARTICLES_CATEGORIES_PATH)}>
        {getText(['words', 'articles'])}
        {(!isLaptop) ? <ArrowIcon /> : null}
      </TitleLinkArrow>
      <HomeTabs
        tabs={articlesTabs}
        query="tabArticles"
      />
      {isArticlesNew ? articlesNew : articlesPopular}
    </SectionsContent>
  );

  const allArticlesSelection = (
    <SectionsContent withInner={false} withPaddings={false}>
      <ButtonInner>
        <Button onClick={() => history.push(RoutePath.ARTICLES_CATEGORIES_PATH)} themeType={ButtonThemeType.SECONDARY}>
          {getText(['words', 'allArticles'])}
        </Button>
      </ButtonInner>
    </SectionsContent>
  );

  const newsSelection = (
    <SectionsContent>
      <TitleLinkArrow onClick={() => history.push(RoutePath.NEWS_CATEGORIES_PATH)}>
        {getText(['words', 'news'])}
        {(!isLaptop) ? <ArrowIcon /> : null}
      </TitleLinkArrow>
      <NewsSliderMain
        data={newsNewData}
        loading={newsNewLoading}
      />
    </SectionsContent>
  );

  const allNewsSelection = (
    <SectionsContent withInner={false} withPaddings={false}>
      <ButtonInner>
        <Button onClick={() => history.push(RoutePath.NEWS_CATEGORIES_PATH)} themeType={ButtonThemeType.SECONDARY}>
          {getText(['words', 'allNews'])}
        </Button>
      </ButtonInner>
    </SectionsContent>
  );

  return (
    <Content>
      {booksTitle}
      {bannersSelection}
      {booksTypesSelection}
      {booksPopularSelection}
      {booksNewSelection}
      {booksSelectedSelection}
      {booksRecommendSelection}
      {booksParentsSelection}
      {allBooksSelection}
      {journalsTitle}
      {selectEditorSelection}
      {freeSelection}
      {thematicSelection}
      {newJournalsSelection}
      {allJournalsSelection}
      {articlesSelection}
      {allArticlesSelection}
      {newsSelection}
      {allNewsSelection}
    </Content>
  );
};

export default HomeView;
